module.exports = __webpack_public_path__ + "img/nowserving.17e6c320.png";